// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"9e506500","422":"3c5923e7","484":"0ac23d44","551":"72093323","828":"3e12adb9"}[chunkId] + ".chunk.js";
};